// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2HQqW","topBottomGutter":"Layout_topBottomGutter__1-xEj"};